export const graphql_server_url = "https://prod-data-api-judrztptdq-uc.a.run.app/graphql"
export const grapgql_prod_url = "https://prod-data-api-judrztptdq-uc.a.run.app/graphql";
export const graphql_local_url = "http://localhost:4000/graphql";
export const access_token = null